export default __webpack_public_path__ + "static/media/master-card.42438828.svg";